// extracted by mini-css-extract-plugin
export default {"modal":"Modals_modal__2iAsx","modalBody":"Modals_modalBody__rokOG"};